import { render, staticRenderFns } from "./AddToHome.vue?vue&type=template&id=8955bf74&scoped=true&"
import script from "./AddToHome.vue?vue&type=script&lang=js&"
export * from "./AddToHome.vue?vue&type=script&lang=js&"
import style0 from "./AddToHome.vue?vue&type=style&index=0&id=8955bf74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8955bf74",
  null
  
)

export default component.exports